const degrees_to_radians = (degrees) =>{
  var pi = Math.PI;
  return degrees * (pi/180);
}

exports.degrees_to_radians = degrees_to_radians;

const radians_to_degrees = (radians) =>{
  var pi = Math.PI;
  return radians * (180/pi);
}

exports.radians_to_degrees = radians_to_degrees;

const get_distance = (x1, y1, x2, y2) =>{
  let y = x2 - x1;
  let x = y2 - y1;

  return Math.sqrt(x * x + y * y);
}


exports.get_distance = get_distance;

const shuffle = (array) =>{
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}

exports.shuffle = shuffle;
